import { AllowanceModel } from "../../../models/allowances/allowanceModel";

export interface BonusAssignmentModel {
    id: number;
    amount: number;
    preliquidationDaySummaryId: number;
    bonusRuleId: number;
    createdById: number;
    createdDate: string;
    bonusRule: BonusRuleModel;
    employee: EmployeeModel;
    date: string;
    createdBy: CreatedByModel;
}

export interface BonusRuleModel {
    id: number;
    name: string;
    description: string;
    allowanceId: number;
    allowance: AllowanceModel;
}

export interface EmployeeModel {
    id: number;
    firstName: string;
    middleName: string;
    lastName: string;
    surname: string;
    documentNumber: string;
}

export interface CreatedByModel {
    id: number;
    name: string;
    lastName: string;
}

export const getEmployeeFullName = (employee: EmployeeModel): string => {
    const parts = [
        employee.firstName,
        employee.middleName,
        employee.lastName,
        employee.surname,
    ].filter(Boolean);
    return parts.join(' ');
};